import { render, staticRenderFns } from "./TabMedicalDevice.vue?vue&type=template&id=48afb7c8&scoped=true"
import script from "./TabMedicalDevice.vue?vue&type=script&lang=js"
export * from "./TabMedicalDevice.vue?vue&type=script&lang=js"
import style0 from "./TabMedicalDevice.vue?vue&type=style&index=0&id=48afb7c8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48afb7c8",
  null
  
)

export default component.exports